let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d767x")).then(() => parcelRequire('5m93C'));